// premium-roast.js
(function(){
  if (typeof window === 'undefined') return;

  function startObserver() {
    var section = document.querySelector('.premium-roast-section');
    if (!section) return;

    // If already animated (e.g., user refreshed after trigger), don't re-run
    var triggered = false;

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting && !triggered) {
          triggered = true;
          section.classList.add('in-view');

          // Optional: slightly stagger the focus by forcing reflow (ensures CSS gets applied)
          // Force repaint
          void section.offsetWidth;

          // we unobserve after animation started
          io.unobserve(section);
        }
      });
    }, { threshold: 0.36 });

    io.observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { passive:true });
  } else {
    startObserver();
  }
})();
